import { createFileRoute, redirect } from '@tanstack/react-router';
import { ChangePasswordPage } from '../pages/auth/change-password-page';
import { isAuthenticated, mustResetPassword } from '../auth/session';

export const Route = createFileRoute('/change-password')({
  beforeLoad: () => {
    if (!isAuthenticated()) {
      throw redirect({ to: '/login' });
    }
    if (!mustResetPassword()) {
      throw redirect({ to: '/contests' });
    }
  },
  component: ChangePasswordPage,
});
